import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$spaceSlug/documents/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$spaceSlug/library', params, replace: true });
  },
});
